module.exports = __webpack_public_path__ + "static/media/workload-search-icon.413e6a62.svg";